import { OptionsApi } from '@core/swagger-client';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/organized/$tab')({
    // The tab's list is there on the first render, so the router restores the scroll position into the full list,
    // not into the loading state. A failure is left to the page, which shows its own error.
    loader: {
        handler: async ({ context, params }) => {
            if (!context.isAuthenticated) return;
            const list = params.tab === 'ended' ? OptionsApi.webinars.getMyEnded() : params.tab === 'upcoming' ? OptionsApi.webinars.getMyUpcoming() : undefined;
            if (list) await context.queryClient.ensureQueryData(list).catch(() => undefined);
        },
        // Also on a return to the overview: by default the router renders a match it has seen before right away and
        // reloads it in the background, which after a delete would restore the position into the loading state.
        // From the cache this costs nothing; it only waits when the lists were dropped.
        staleReloadMode: 'blocking'
    }
});
